import React, { useEffect } from 'react'
import { Grid, Typography, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import giftList from './giftList'

const styles = theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start'
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '270px',
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  img: {
    width: '200px',
    maxHeight: '200px'
  },
  cardFooter: {
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  notification: {
    maxWidth: '150px'
  }
})

const ShopCard = withStyles(styles)(({ classes, img, price, onPurchase, isLoading, notification }) => {
  const { t } = useTranslation()

  return (
    <Grid item className={classes.card}>
      <img src={img} className={classes.img} alt='' />

      <div className={classes.cardFooter}>
        <Typography variant='body2'>
          {`$${price}`}
        </Typography>
        { notification
          ? (
            <Typography variant='subtitle2' className={classes.notification}>
              {t('Cabinet:gift purchased')}
            </Typography>
          )
          : (
            <Button variant='outlined' onClick={onPurchase} disabled={isLoading}>
              {t('Cabinet:purchase')}
            </Button>
          )}
      </div>
    </Grid>
  )
})

const Shop = ({ classes, isLoading, notification, onPurchase, gifts, fetchGifts }) => {
  useEffect(() => {
    if (!isLoading && gifts === undefined) {
      fetchGifts()
    }
  })

  return (
    <Grid container className={classes.container}>
      { giftList.map(({ id, price, image }) => (
        <ShopCard
          key={id}
          price={price}
          img={image}
          onPurchase={() => onPurchase(id)}
          isLoading={isLoading}
          notification={notification === id}
        />
      )) }
    </Grid>
  )
}

export default withStyles(styles)(Shop)
